import dayjs from 'dayjs';
import { formatDay, formatDayFromUtc } from '../../../utils/date';
import { IReportResult } from '../reports/types';
import { IDateRange } from '../settings/dates/dateRangeProvider';

/**
 * @description formats a give timeframe as a string
 * @param start
 * @param end
 * @returns
 */
export const formatTimeframe = (
  start: number | null,
  end: number | null,
  localTime: boolean = false
): string => {
  if (localTime) {
    return start ? `${formatDay(start)} - ${formatDay(end)}` : '';
  }
  return start ? `${formatDayFromUtc(start)} - ${formatDayFromUtc(end)}` : '';
};

/**
 * @description formats the overall timeframe from a list of report results
 * @param results
 * @returns
 */
export const formatTimeframeFromReportResults = (
  results: IReportResult[]
): string => {
  let start: number = Infinity;
  let end: number = -Infinity;
  if (results?.length) {
    for (const result of results) {
      if (result.timestamp < start) {
        start = result.timestamp;
      }
      if (result.end > end) {
        end = result.end;
      }
    }
    return start ? `${formatDayFromUtc(start)}-${formatDayFromUtc(end)}` : '';
  }
  return null;
};

/**
 * @description converts a timeframe with UTC values to local time
 * @param dateRange
 * @returns
 */
export const convertTimeframeToLocalTime = (
  dateRange: IDateRange
): IDateRange => {
  if (dateRange?.dateType?.value !== 'custom') return dateRange;
  const { to, from } = dateRange.dateRange;
  const localTo = {
    label: formatDayFromUtc(to.value),
    value: dayjs.utc(to.value).valueOf(),
  };
  const localFrom = {
    label: formatDayFromUtc(from.value),
    value: dayjs.utc(from.value).valueOf(),
  };
  return {
    dateType: dateRange.dateType,
    dateRange: {
      to: localTo,
      from: localFrom,
    },
  };
};
